var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg8(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 406,
    height: 386,
    viewBox: "-65 9 406 386",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Man / Head / 8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Head"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M312.133 154.56C312.133 154.56 362.859 220.853 293.987 238.451L312.133 154.56Z",
    fill: "#19141E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Face color"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Face",
    d: "M217.618 382.451L215.931 323.998C215.931 323.998 288.528 329.653 303.679 321.76C303.679 321.76 315.194 250.731 304.245 200.37L244.635 146.39L148.433 153.494L137.514 240.817C132.48 225.924 86.6543 207.254 75.6538 240.664C61.4685 283.745 143.23 306.384 143.23 306.384L134.686 383.154",
    fill: "#5E93D1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Hair",
    d: "M104.176 150.166L80.6196 126.099L93.4832 113.508L114.996 135.487L117.091 134.482L111.541 103.516L129.258 100.341L133.706 125.156C176.612 98.8893 210.499 119.364 210.499 119.364C210.499 119.364 224.175 61.8362 262.032 62.0018C315.963 62.235 324.286 145.802 324.286 145.802C324.286 145.802 351.468 100.355 366.924 106.851C382.38 113.349 382.806 264.297 168.226 190.735C168.226 190.735 186.677 232.363 137.514 240.818C137.514 240.818 128.94 223.049 99.8829 222.045C99.8829 222.045 55.1929 203.81 104.176 150.166Z",
    fill: "#19141E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 10",
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.931 323.997L168.174 313.727L215.702 345.927L215.931 323.997Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.234 236.043L272.735 276.507L252.958 276.76L256.234 236.043Z",
    fill: "#125475"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.508 239.974C237.491 245.423 233.882 250.639 228.451 251.623C223.017 252.61 217.816 248.992 216.834 243.543C215.851 238.094 219.458 232.878 224.891 231.893C230.325 230.907 235.524 234.524 236.508 239.974Z",
    fill: "#0D0B6D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M288.412 239.974C289.395 245.423 285.786 250.639 280.353 251.623C274.921 252.61 269.719 248.992 268.738 243.543C267.754 238.094 271.361 232.878 276.795 231.893C282.229 230.907 287.428 234.524 288.412 239.974Z",
    fill: "#0D0B6D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 18",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.673 283.148C230.673 283.148 237.023 294.72 250.746 294.446L230.673 283.148Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 20",
    d: "M230.673 283.148C230.673 283.148 237.023 294.72 250.746 294.446",
    stroke: "#252535",
    strokeWidth: 4
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg8);
export default __webpack_public_path__ + "static/media/8.1b357729.svg";
export { ForwardRef as ReactComponent };